import { render, staticRenderFns } from "./OAStartFlow.vue?vue&type=template&id=f4086efa&scoped=true"
import script from "./OAStartFlow.vue?vue&type=script&lang=js"
export * from "./OAStartFlow.vue?vue&type=script&lang=js"
import style0 from "./OAStartFlow.vue?vue&type=style&index=0&id=f4086efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4086efa",
  null
  
)

export default component.exports